module.exports = __webpack_public_path__ + "img/no-company-bg.e571059d.png";